<template>
  <div class="update-password-box">
    <el-dialog title="修改密码" :visible.sync="show" :close-on-click-modal='false' :modal='false'>
      <!-- 修改密码表单区域 -->
      <el-form ref="modifyFormRef" :model="modifyForm" label-position="left" :rules="modifyFormRules" label-width="80px" class="modify_form" v-if="show">
        <!-- 密码 -->
        <el-form-item prop="newpassword" label="新密码">
          <el-input v-model="modifyForm.newpassword" type="password"></el-input>
        </el-form-item>
        <el-form-item prop="repassword" label="确认密码">
          <el-input v-model="modifyForm.repassword" type="password"></el-input>
        </el-form-item>
        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button type="primary" @click="modify">确认</el-button>
          <el-button type="info" @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import * as loginApi from '../../api/userAPI'
import md5 from 'js-md5'

export default {
  components: {

  },
  props: {
    show: Boolean
  },
  data() {
    return {
      userInfo: {},
      modifyForm: {
        repassword: '',
        newpassword: '',

      },
      modifyFormRules: {
        repassword: [{ required: true, message: '请输入确认密码', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (value != this.modifyForm.newpassword) {
              callback(new Error("确认密码与新密码不一致"));
            } else {
              //校验通过
              callback();
            }
          },
          trigger: "blur"
        }],
        newpassword: [{ required: true, message: '请输入新密码', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/.test(value)) {
              callback(new Error("必须包含大写字母、小写字母、数字、特殊符号"));
    
            } else {
              //校验通过
              callback();
            }
          },
          trigger: "blur"
        }
        ],
      }
    };
  },
  computed: {

  },
  watch: {

  },
  async created() {
    this.userInfo = await this.$store.getters.getUserInfo
  },
  mounted() {

  },
  methods: {
    modify() {//修改密码
      this.$refs.modifyFormRef.validate(async valid => {
        if (!valid) return

        let encode1 = md5(this.modifyForm.newpassword);
        let newpassword = md5(this.modifyForm.newpassword + encode1.substring(5, 10))
        let param = { newpassword }
        let res = await loginApi.modifyPassword(param)
        if (res.flag) {
          this.$message.success("密码修改成功！")
            this.cancel()
        }

      })
    },
    cancel() {
      this.$refs.modifyFormRef.resetFields()
      this.$emit('dialogClose')
    }
  },
};
</script>

<style  lang="less" scoped>
.modify_form {
  //   position: absolute;
  bottom: 10px;
  width: 100%;
  padding: 0 40px;
  box-sizing: border-box;
  background: #fff;
}
.btns {
  display: flex;
  justify-content: flex-end;
}
</style>
